module.exports = __webpack_public_path__ + "img/20.b482ecb6.png";